<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CRoNKY/tc-custom/9781421423609.jpg?1705065586082" alt="This image is the cover for the book American Snakes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Snakes
      </h1>
      <p class="bookDescription body article font2">
        <b>“A wonderful book to read because it is replete with snake stories, personal stories, and stories about other herpetologists . . . engaging.” —<i>Copeia</i></b><br/><br/>Although many people fear them, snakes are as much a part of America’s rich natural heritage as redwoods, bald eagles, and grizzly bears. Found from the vast Okefenokee Swamp to high alpine meadows, from hardwood canopies to the burning bottom of the Grand Canyon, these ultimate vertebrates are ecologically pivotal predators and quintessential survivors.<br/><br/>In this revelatory and engaging meditation on American snakes, Sean P. Graham, a respected herpetologist and gifted writer,explains the everyday lives of American snakes, from their daily routines and seasonal cycles to their love lives, hunting tactics, and defensive repertoiresdebunks harmful myths about snakes and explores their relationship with humanshighlights the contribution of snakes to the American wildernesstells tales of “snake people”—important snake biologists with inspiring careers<br/><br/>Neither a typical field guide nor an exhaustive reference, <i>American Snakes</i> is instead a fascinating study of the suborder Serpentes. Brimming with intriguing and unusual stories—of hognose snakes that roll over and play dead, blindsnakes with tiny vestigial lungs, rainbow-hued dipsadines, and wave-surfing sea-snakes—the text is interspersed with scores of gorgeous full-color images of snakes, from the scary to the sublime. This proud celebration of a diverse American wildlife group will make every reader, no matter how skeptical, into a genuine snake lover.<br/><br/><b>“This thoroughly enjoyable book lets readers absorb the excitement of being a herpetologist who works with snakes while learning about the general and specific biology of the creatures.” —<i>Quarterly Review of Biology</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean P. Graham, Rick Shine
      </h2>
      
      <p class="authorDescription body article">Sean P. Graham is an assistant professor of biology at Sul Ross State University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c2e5a60